import styled from 'styled-components';

export const CarouselItem = styled.div`
  min-height: 4rem;
  border-radius: 0.8rem;
  border: 1px solid ${(props) => props.selected ? '#008cff' : 'white'};
  background-color: ${(props) => props.selected ? '#eaf5ff' : 'white'};
  display: ${(props) => props.package_id ? 'block' : 'flex'} ;
  align-items: center;
  justify-content: center;
  margin-right: 1.5rem;
  padding: 0.5rem 1rem;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: ${(props) => props.selected ? '#008cff' : '#4a4a4a'};
  cursor: pointer;

  .title {
    width: 100%;
    text-align: center;
  }

  .rubik {
    font-family: 'Rubik';
    font-weight: 600;
  }

  span {
    padding-right: 4px;
  }

  .priceText {
    margin-top: 4px;
    font-size: 1.2rem;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
